import { combineReducers } from 'redux';

import apiKey from 'src/modules/apiKey/apiKeyReducers';
import appUser from 'src/modules/appUser/appUserReducers';
import asset from 'src/modules/asset/assetReducers';
import auditLog from 'src/modules/auditLog/auditLogReducers';
import auth from 'src/modules/auth/authReducers';
import dataStudio from 'src/modules/dataStudio/dataStudioReducers';
import flowStep from 'src/modules/flowStep/flowStepReducers';
import formCategory from 'src/modules/formCategory/formCategoryReducers';
import formTemplate from 'src/modules/formTemplate/formTemplateReducers';
import indicator from 'src/modules/indicator/indicatorReducers';
import keyword from 'src/modules/keyword/keywordReducers';
import layout from 'src/modules/layout/layoutReducers';
import location from 'src/modules/location/locationReducers';
import notification from 'src/modules/notification/notificationReducers';
import plan from 'src/modules/plan/planReducers';
import resource from 'src/modules/resource/resourceReducers';
import settings from 'src/modules/settings/settingsReducers';
import tenant from 'src/modules/tenant/tenantReducers';
import user from 'src/modules/user/userReducers';
import workflow from 'src/modules/workflow/workflowReducers';
import workflowLaunch from 'src/modules/workflowLaunch/workflowLaunchReducers';

const rootReducers = {
  auth,
  settings,
  layout,
  tenant,
  plan,
  user,
  auditLog,
  location,
  resource,
  keyword,
  formCategory,
  asset,
  notification,
  formTemplate,
  workflow,
  flowStep,
  dataStudio,
  appUser,
  apiKey,
  indicator,
  workflowLaunch,
};

export default (routerReducer) =>
  combineReducers({
    router: routerReducer,
    ...rootReducers,
  });
